const nativeFetch = window.fetch.bind(window);

/* =========================================================
   CONTADOR DEL CARRITO
   ========================================================= */

function renderCartCount(count) {
  const value = Number(count) || 0;

  document.querySelectorAll('.rf-cart-count').forEach((badge) => {
    badge.textContent = value > 99 ? '99+' : String(value);
    badge.hidden = value === 0;

    if (value > 0 && typeof badge.animate === 'function') {
      badge.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.35)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 350,
          easing: 'ease-out'
        }
      );
    }
  });
}

async function syncCartCount() {
  try {
    const root = window.Shopify?.routes?.root || '/';

    const response = await nativeFetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) return;

    const cart = await response.json();
    renderCartCount(cart.item_count);
  } catch (error) {
    console.warn('[Reflection] Cart count sync failed', error);
  }
}

function scheduleCartSync() {
  window.setTimeout(syncCartCount, 80);
  window.setTimeout(syncCartCount, 300);
  window.setTimeout(syncCartCount, 700);
}

/* =========================================================
   FETCH — AJAX MODERNO
   ========================================================= */

window.fetch = async (...args) => {
  const response = await nativeFetch(...args);

  try {
    const request = args[0];

    const url =
      typeof request === 'string'
        ? request
        : request instanceof Request
          ? request.url
          : '';

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      scheduleCartSync();
    }
  } catch (error) {
    // Nunca bloquear una compra por el contador.
  }

  return response;
};

/* =========================================================
   XHR — QUICK ADD / COLECCIONES
   ========================================================= */

const nativeXHROpen = XMLHttpRequest.prototype.open;
const nativeXHRSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this.__reflectionCartUrl = String(url || '');

  return nativeXHROpen.call(
    this,
    method,
    url,
    ...rest
  );
};

XMLHttpRequest.prototype.send = function (...args) {
  const url = this.__reflectionCartUrl || '';

  if (
    url.includes('/cart/add') ||
    url.includes('/cart/change') ||
    url.includes('/cart/update') ||
    url.includes('/cart/clear')
  ) {
    this.addEventListener(
      'loadend',
      () => {
        scheduleCartSync();
      },
      { once: true }
    );
  }

  return nativeXHRSend.apply(this, args);
};

/* =========================================================
   FORM — FALLBACK ADD TO CART
   ========================================================= */

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || form.action || '';

    if (action.includes('/cart/add')) {
      scheduleCartSync();
    }
  },
  true
);

/* =========================================================
   ANIMACIÓN PRODUCTO → CARRITO
   ========================================================= */

function flyToCart(trigger) {
  const cartIcon = document.querySelector('.rf-cart-link');

  if (!cartIcon || !trigger) return;

  let current = trigger;
  let image = null;

  /*
   * Sube por la estructura HTML hasta encontrar
   * una imagen visible asociada al producto.
   */
  for (let i = 0; i < 12 && current; i++) {
    const images = current.querySelectorAll?.('img');

    if (images?.length) {
      image = Array.from(images).find((img) => {
        const rect = img.getBoundingClientRect();

        return (
          rect.width > 70 &&
          rect.height > 70 &&
          rect.bottom > 0 &&
          rect.top < window.innerHeight
        );
      });

      if (image) break;
    }

    current = current.parentElement;
  }

  const cartRect = cartIcon.getBoundingClientRect();
  const source = image || trigger;
  const sourceRect = source.getBoundingClientRect();

  const flyer = image
    ? image.cloneNode(true)
    : document.createElement('div');

  const startSize = image
    ? Math.min(90, sourceRect.width, sourceRect.height)
    : 28;

  Object.assign(flyer.style, {
    position: 'fixed',
    left: `${sourceRect.left + sourceRect.width / 2 - startSize / 2}px`,
    top: `${sourceRect.top + sourceRect.height / 2 - startSize / 2}px`,
    width: `${startSize}px`,
    height: `${startSize}px`,
    zIndex: '9999999',
    pointerEvents: 'none',
    borderRadius: image ? '12px' : '999px',
    objectFit: image ? 'cover' : '',
    background: image ? '' : '#ffffff',
    boxShadow: '0 12px 35px rgba(0,0,0,.45)'
  });

  document.body.appendChild(flyer);

  const startX =
    sourceRect.left +
    sourceRect.width / 2;

  const startY =
    sourceRect.top +
    sourceRect.height / 2;

  const endX =
    cartRect.left +
    cartRect.width / 2;

  const endY =
    cartRect.top +
    cartRect.height / 2;

  const deltaX = endX - startX;
  const deltaY = endY - startY;

  const animation = flyer.animate(
    [
      {
        transform: 'translate(0, 0) scale(1)',
        opacity: 1
      },
      {
        transform: `translate(${deltaX * 0.45}px, ${deltaY * 0.35 - 70}px) scale(.72)`,
        opacity: .95,
        offset: .45
      },
      {
        transform: `translate(${deltaX}px, ${deltaY}px) scale(.12)`,
        opacity: .1
      }
    ],
    {
      duration: 750,
      easing: 'cubic-bezier(.22,.8,.25,1)',
      fill: 'forwards'
    }
  );

  animation.onfinish = () => {
    flyer.remove();

    if (typeof cartIcon.animate === 'function') {
      cartIcon.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.28)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 300,
          easing: 'ease-out'
        }
      );
    }
  };
}

/* =========================================================
   CLICK EN AÑADIR AL CARRITO
   ========================================================= */

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest(
      'button, [type="submit"], [role="button"]'
    );

    if (!button) return;

    const text = (button.textContent || '')
      .trim()
      .toLowerCase();

    if (
      text.includes('añadir al carrito') ||
      text.includes('add to cart')
    ) {
      flyToCart(button);
      scheduleCartSync();
    }
  },
  true
);

/* =========================================================
   SINCRONIZACIÓN INICIAL
   ========================================================= */

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    syncCartCount,
    { once: true }
  );
} else {
  syncCartCount();
}

window.addEventListener('pageshow', syncCartCount);